module.exports = __webpack_public_path__ + "img/work_environment1.0091fb0e.png";